<ng-container *transloco="let t; read: 'configuration'">
<div>
  <div class="flex justify-between border-b mb-3">
    <h1 class="text-[25px] font-bold mr-12">{{ t('lockingStatus.editTitle') }}</h1>
    <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle"></i>
  </div>

  <div mat-dialog-content>
    <form class="grid sm:grid-cols-2 gap-x-4" [formGroup]="lockingStatusForm">
      <div class="items-center w-[100%] pl-3">
        <drdp-date-picker [label]="t('lockingStatus.lockDateLabel')"
          [initialDate]="lockingStatusForm.get('lockDate').value"
          (emitDate)="handleDate($event)">
        </drdp-date-picker>
      </div>
      <div class="md:pl-8 pl-3">
        <label class="font-normal" for="active">{{ t('lockingStatus.activeLabel') }}</label>
        <div class="pt-6">
          <mat-checkbox [color]="'primary'" class="example-margin font-normal" formControlName="active">
          </mat-checkbox>
        </div>
      </div>
    </form>
  </div>
  <div mat-dialog-actions class="flex justify-end bottom-0">
    <button mat-button mat-dialog-close>{{ t('common.cancel') }}</button>
    @if (lockingStatusForm.valid) {
      <drdp-btn mat-button [mat-dialog-close]="onSubmit()" [disabled]="false"
        cdkFocusInitial>
        {{ t('common.save') }}
      </drdp-btn>
    }
    @if (!lockingStatusForm.valid) {
      <drdp-btn mat-button [disabled]="true" cdkFocusInitial>{{ t('common.save') }}</drdp-btn>
    }
  </div>
</div>
</ng-container>
